import React from "react";
import { File } from "@phosphor-icons/react";

interface DocumentTypeIconProps {
  type:
    | "packing"
    | "si"
    | "fe"
    | "invoice"
    | "pd"
    | "uh"
    | "df"
    | "bl"
    | "custom";
  customText?: string;
  customColor?: string;
  size?: number;
  className?: string;
}

const ICON_PRESETS = {
  packing: {
    text: "PK",
    backgroundColor: "#34A853", // Green
  },
  si: {
    text: "SI",
    backgroundColor: "#00BCD4", // Cyan
  },
  fe: {
    text: "FE",
    backgroundColor: "#FF6B35", // Orange
  },
  invoice: {
    text: "IV",
    backgroundColor: "#4285F4", // Blue
  },
  pd: {
    text: "PD",
    backgroundColor: "#34A853", // Green
  },
  uh: {
    text: "UH",
    backgroundColor: "#FF6B35", // Orange
  },
  df: {
    text: "DF",
    backgroundColor: "#9C27B0", // Purple
  },
  bl: {
    text: "BL",
    backgroundColor: "#FF9800", // Amber
  },
};

export const DocumentTypeIcon: React.FC<DocumentTypeIconProps> = ({
  type,
  customText,
  customColor,
  size = 64,
  className = "",
}) => {
  const preset =
    type === "custom"
      ? { text: customText || "??", backgroundColor: customColor || "#6B7280" }
      : ICON_PRESETS[type];

  const textSize = size * 0.35; // 25% of icon size

  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width: size, height: size }}
    >
      {/* File Icon Background */}
      <File
        size={size}
        weight="fill"
        style={{ color: preset.backgroundColor }}
        className="w-full h-full"
      />

      {/* Text Overlay */}
      <div
        className="absolute inset-0 flex items-center justify-center select-none"
        style={{
          top: "15%",
          color: "#ffffffe5",
          fontSize: textSize,
          fontWeight: 600,
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          letterSpacing: "0.5px",
          textShadow: "0 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        {preset.text}
      </div>
    </div>
  );
};

export const getFileIcon = (type: string) => {
  switch (type) {
    case "packing":
      return <DocumentTypeIcon type="packing" size={38} />;
    case "si":
      return <DocumentTypeIcon type="si" size={38} />;
    case "fe":
      return <DocumentTypeIcon type="fe" size={38} />;
    case "invoice":
      return <DocumentTypeIcon type="invoice" size={38} />;
    case "pd":
      return <DocumentTypeIcon type="pd" size={38} />;
    case "uh":
      return <DocumentTypeIcon type="uh" size={38} />;
    case "df":
      return <DocumentTypeIcon type="df" size={38} />;
    case "bl":
      return <DocumentTypeIcon type="bl" size={38} />;
    default:
      return (
        <DocumentTypeIcon
          type="custom"
          customText="F"
          customColor="#6B7280"
          size={38}
        />
      );
  }
};
